"use client";

import { usePathname } from "next/navigation";
import Script from "next/script";
import { useReportWebVitals } from "next/web-vitals";
import { Fragment } from "react";
import { useRouteChange } from "~/hooks/useRouteChange";

declare global {
	interface Window {
		dataLayer: unknown[];
	}
}

export function GoogleTagManagerInit(props: { gtmId: string }) {
	if (process.env.NODE_ENV !== "production") {
		return null;
	}

	return (
		<>
			<Script
				id="googletagmanager"
				dangerouslySetInnerHTML={{
					__html: `
              (function (w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
                var f = d.getElementsByTagName(s)[0],
                  j = d.createElement(s),
                  dl = l != "dataLayer" ? "&l=" + l : "";
                j.async = true;
                j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
                f.parentNode.insertBefore(j, f);
              })(window, document, "script", "dataLayer", "${props.gtmId}");
            `,
				}}
			/>
			<Script
				id="google-analytics"
				dangerouslySetInnerHTML={{
					__html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());

              gtag('config', '${props.gtmId}', {
                page_path: window.location.pathname,
              });
            `,
				}}
			/>
		</>
	);
}

export function GoogleTagManagerScript(props: { gtmId: string }) {
	if (process.env.NODE_ENV !== "production") {
		return null;
	}

	const pathname = usePathname();

	useRouteChange(() => window.dataLayer?.push({ event: "pageview", page: pathname }));

	useReportWebVitals((metric: { name: string; value: number; id: string }) => {
		if (window.gtag) {
			window.gtag("event", metric.name, {
				value: Math.round(metric.name === "CLS" ? metric.value * 1000 : metric.value), // values must be integers
				event_label: metric.id, // id unique to current page load
				non_interaction: true, // avoids affecting bounce rate.
			});
		}
	});

	return (
		<Fragment>
			<noscript>
				<iframe
					title="Google Tag Manager"
					src={`https://www.googletagmanager.com/ns.html?id=${props.gtmId}`}
					height="0"
					width="0"
					style={{ display: "none", visibility: "hidden" }}
				/>
			</noscript>
			<Script
				strategy="afterInteractive"
				src={`https://www.googletagmanager.com/gtag/js?id=${props.gtmId}`}
			/>
		</Fragment>
	);
}
